import axios from "axios";

const baseURL = process.env.REACT_APP_API_URL;

const externalAPI = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
    accept: "application/json",
  },
});

externalAPI.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("sessionToken");
    if (token) {
      config.headers["Authorization"] = "SessionToken " + token;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

const PERMANENT_CODES = ["SESSION_EXPIRED", "SESSION_UNAVAILABLE"];
const PERMANENT_MESSAGES = [
  "Invalid or expired session token",
  "Session is not linked",
  "Session is active on another device",
];

externalAPI.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    if (status === 401 || status === 403) {
      const data = error?.response?.data;
      const code = data?.error_code;
      const message = data?.error || data?.detail || "";

      const isPermanent =
        PERMANENT_CODES.includes(code) ||
        PERMANENT_MESSAGES.some((m) => message.includes(m));

      if (isPermanent) {
        sessionStorage.removeItem("sessionToken");
      }
    }
    return Promise.reject(error);
  }
);

export default externalAPI;
